import { WppIconChevron, WppSelect } from '@wppopen/components-library-react'
import clsx from 'clsx'

import stylesMain from 'assets/css/main.module.scss'
import { Flex } from 'components/common/flex/Flex'

import styles from './Pagination.module.scss'

interface Props {
  page: number
  allPages: number
  itemsPerPage: number
  allItems: number
  onSelectPage: (page: number) => void
  onSelectItemsPerPage: (number: number) => void
  disabled?: boolean
}

export const Pagination = ({
  page,
  allPages,
  itemsPerPage,
  allItems,
  onSelectPage,
  onSelectItemsPerPage,
  disabled,
}: Props) => {
  return (
    <div
      style={{ paddingLeft: 14, paddingRight: 14, marginTop: 24, width: '100%' }}
      className={clsx({ [styles.disabled]: disabled })}
    >
      <Flex align="center" justify="between">
        <Flex gap={6} align="center">
          <div style={{ color: '#4C4C4C' }} className={stylesMain.SBody}>
            Items per page:
          </div>
          <WppSelect
            disabled={disabled}
            type="text"
            dropdownWidth="auto"
            dropdownConfig={{ interactive: true }}
            size="s"
            list={[
              { label: '6', value: 6 },
              { label: '12', value: 12 },
              { label: '18', value: 18 },
              { label: '20', value: 20 },
            ]}
            onWppChange={(e: CustomEvent) => {
              onSelectItemsPerPage(e.detail.value)
            }}
            value={itemsPerPage}
          />

          <div className={styles.separator} />
          <div
            style={{ color: '#4C4C4C', marginLeft: 16 }}
            className={stylesMain.SBody}
          >{`${(page - 1) * itemsPerPage + 1}-${page * itemsPerPage} of ${allItems} items`}</div>
        </Flex>
        <Flex align="center" gap={8}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (disabled) return
              page !== 1 && onSelectPage(page - 1)
            }}
          >
            <WppIconChevron color="#A5A5A5" direction="left" />
          </div>
          <div className={clsx(styles.currentPage, stylesMain.blackPMobile)}>{page}</div>
          <div className={styles.separator} />
          <div className={clsx(styles.allPages, stylesMain.blackPMobile)}>{allPages}</div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (disabled) return
              if (page !== allPages) {
                onSelectPage(page + 1)
              }
            }}
          >
            <WppIconChevron color="#8B919A" direction="right" />
          </div>
        </Flex>
      </Flex>
    </div>
  )
}
